import React, { useEffect, useRef, useState } from "react";
import hljs from "highlight.js";
import ReactQuill from "react-quill-new";
import { Link } from "react-router-dom";
import { createEmailTemplate } from "../../apiHelper/authService";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { clearSelectedEmailTemplate } from "../../redux/authModalSlice";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
const AddEmailTemp = () => {
    const navigate = useNavigate()
    const [imagePreview, setImagePreview] = useState(null);
    const { selectedEmailTemplate } = useSelector((state) => state.authModal);
    const { user } = useSelector((state) => state.authModal);
    const fromCountry = user?.from;
    const toCountry = user?.to;

    // const handleFileChange = (e) => {
    //     if (e.target.files && e.target.files.length > 0) {
    //         const src = URL.createObjectURL(e.target.files[0]);
    //         setImagePreview(src);
    //     }
    // };

    // const handleRemoveImage = () => {
    //     setImagePreview(null);
    // };
    const quillRef = useRef(null);
    const [value, setValue] = useState(``);
    // eslint-disable-next-line no-unused-vars
    const [isHighlightReady, setIsHighlightReady] = useState(false);
    const dispatch = useDispatch()

    useEffect(() => {
        // Load highlight.js configuration and signal when ready
        hljs?.configure({
            languages: [
                "javascript",
                "ruby",
                "python",
                "java",
                "csharp",
                "cpp",
                "go",
                "php",
                "swift",
            ],
        });
    }, []);

    // eslint-disable-next-line no-unused-vars
    const handleSave = () => {
        const editorContent = quillRef.current.getEditor().root.innerHTML;
        console.log("Editor content:", editorContent);
    };

    // Quill editor modules with syntax highlighting (only load if highlight.js is ready)
    const modules = isHighlightReady
        ? {
            syntax: {
                highlight: (text) => hljs?.highlightAuto(text).value, // Enable highlight.js in Quill
            },
            toolbar: {
                container: "#toolbar-container", // Custom toolbar container
            },
        }
        : {
            toolbar: {
                container: "#toolbar-container", // Custom toolbar container
            },
        };

    const formats = [
        "font",
        "size",
        "bold",
        "italic",
        "underline",
        "strike",
        "color",
        "background",
        "script",
        "header",
        "blockquote",
        "code-block",
        "list",
        "indent",
        "direction",
        "align",
        "link",
        "image",
        "video",
        "formula",
    ];


    const [title, setTitle] = useState('');
    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false)

    const [emailid, setEmailId] = useState(''); // can be generated or user-input
    const [mailImage, setMailImage] = useState(null);
    //   const [imagePreview, setImagePreview] = useState(null);

    //   const quillRef = useRef();
    const [imageName, setImageName] = useState('');
    // const handleFileChange = (e) => {
    //     const file = e.target.files[0];
    //     if (file) {
    // setMailImage(file);
    //         setImagePreview(URL.createObjectURL(file));
    //     }
    // };

    // const handleRemoveImage = () => {
    //     setMailImage(null);
    //     setImagePreview(null);
    // };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file && file.type.startsWith('image/')) {
            setMailImage(file);

            setImagePreview(URL.createObjectURL(file));
            setImageName(file.name);
        } else {
            alert('Please upload a valid image file');
        }
    };

    const handleRemoveImage = () => {
        setMailImage(null);

        setImagePreview(null);
        setImageName('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();


        if (!value || value === '<p><br></p>') {
            toast.error("Message is required");
            return;
        }

        if (!imagePreview) {
            toast.error("Image is required");
            return;
        }

        setLoading(true)

        // const toastId = toast.loading("Submitting...");



        const formData = new FormData();
        formData.append('title', title);
        formData.append('subject', subject);
        formData.append('message', value);
        formData.append('from', fromCountry);
        formData.append('to', toCountry);
        formData.append('id', emailid);

        // console.log(value)
        if (mailImage) {
            formData.append('mailImage', mailImage);
        }

        try {
            const res = await createEmailTemplate(formData);
            console.log('Success:', res);
            navigate("/email-templates")

            // Reset form if needed
        } catch (err) {
            // toast.error(
            //     err?.message || "Something went wrong while fetching categories.",
            //     { id: toastId }
            // );
            console.error('Error:', err);
        }

        finally {
            setLoading(false)
        }


    };

    //Insert var|

    const insertVariable = (e) => {
        const variable = e.target.value;

        if (!variable || !quillRef.current) return;

        const editor = quillRef.current.getEditor();
        const cursorPosition = editor.getSelection()?.index || 0;
        editor.insertText(cursorPosition, `{${variable}}`);
        editor.setSelection(cursorPosition + variable.length + 2);
        e.target.value = '';
    };


    useEffect(() => {
        if (selectedEmailTemplate) {
            // setCategoryName(selectedCategory.name || '');
            // setIsPublished(selectedCategory.isActive || false);
            // setCategoryId(selectedCategory?.id || '')
            setTitle(selectedEmailTemplate?.title || '')
            setSubject(selectedEmailTemplate?.subject || '')
            setMessage(selectedEmailTemplate?.message || '')
            setValue(selectedEmailTemplate?.message || '')


            setEmailId(selectedEmailTemplate?.id || '')



            // ✅ Setup Image Preview
            if (selectedEmailTemplate?.image) {
                setImagePreview(selectedEmailTemplate.image); // imageUrl should be a valid image path
                const imageName = selectedEmailTemplate.image // Extract filename from URL
                setImageName(imageName);
                setMailImage(selectedEmailTemplate?.image)
            } else {
                setImagePreview(null);
                setImageName('');
                setMailImage('')
            }



        }

        return () => {
            // Clear Redux state when navigating away
            dispatch(clearSelectedEmailTemplate());
        };
    }, [selectedEmailTemplate, dispatch]);

    // console.log(mailImage)


    return (
        <div className='row gy-4'>
            <div className='col-lg-12'>
                <div className='card mt-24'>
                    <div className='card-header border-bottom'>
                        <h6 className='text-xl mb-0'>Add New Email Template</h6>
                    </div>
                    <div className='card-body p-24'>
                        <form onSubmit={handleSubmit} className='d-flex flex-column gap-20'>


                            <div className="row gy-3">
                                <div className="col-12 col-md-6">
                                    <label
                                        className='form-label fw-bold text-neutral-900'
                                        htmlFor='title'
                                    >
                                        Title:{" "}
                                    </label>
                                    <input
                                        type='text'
                                        required
                                        className='form-control border border-neutral-200 radius-8'
                                        id='title'
                                        placeholder='Enter Title'
                                        value={title}
                                        onChange={(e) => setTitle(e.target.value)}
                                    />
                                </div>

                                <div className="col-12 col-md-6">
                                    <label
                                        className='form-label fw-bold text-neutral-900'
                                        htmlFor='subject'
                                    >
                                        Subject:{" "}
                                    </label>
                                    <input

                                        type='text'
                                        required
                                        className='form-control border border-neutral-200 radius-8'
                                        id='subject'
                                        placeholder='Enter Subject'
                                        value={subject}
                                        onChange={(e) => setSubject(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div>
                                <label className='form-label fw-bold text-neutral-900'>
                                    Message
                                </label>
                                <div className='border border-neutral-200 radius-8 overflow-hidden'>
                                    <div className='height-200'>
                                        {/* Toolbar */}
                                        <div id='toolbar-container'>
                                            <span className='ql-formats'>
                                                <select className='ql-font'></select>
                                                <select className='ql-size'></select>
                                            </span>
                                            <span className='ql-formats'>
                                                <button className='ql-bold'></button>
                                                <button className='ql-italic'></button>
                                                <button className='ql-underline'></button>
                                                <button className='ql-strike'></button>
                                            </span>

                                            <span className='ql-formats'>
                                                <button className='ql-list' value='ordered'></button>
                                                <button className='ql-list' value='bullet'></button>
                                                <button className='ql-indent' value='-1'></button>
                                                <button className='ql-indent' value='+1'></button>
                                            </span>


                                        </div>

                                        <ReactQuill
                                            ref={quillRef}
                                            theme='snow'
                                            value={value}
                                            onChange={setValue}
                                            modules={modules}
                                            formats={formats}
                                            placeholder='Compose an epic...'
                                        />
                                    </div>
                                </div>
                            </div>


                            {/* <div>
                                <label className='form-label fw-bold text-neutral-900'>
                                    Insert Variable:{" "}
                                </label>
                                <select className='form-control border border-neutral-200 radius-8'>
                                    <option value=''>Full Name</option>
                                    <option value=''>Email </option>
                                    <option value=''>Mobile Number</option>

                                </select>
                            </div> */}

                            <div className="row gy-3">

                                <div className="col-md-6 col-12">
                                    <label className='form-label fw-bold text-neutral-900'>
                                        Insert Variable:
                                    </label>
                                    <select
                                        // required
                                        className='form-control border border-neutral-200 radius-8'
                                        onChange={insertVariable}
                                    >
                                        <option value=''>Select Variable</option>
                                        <option value='fullname'>Full Name</option>
                                        <option value='email'>Email</option>
                                        <option value='mobile_number'>Mobile Number</option>
                                    </select>
                                </div>

                                {/* <div>
                                <label className='form-label fw-bold text-neutral-900'>
                                    Upload File
                                </label>
                                <div className='upload-image-wrapper'>
                                    {imagePreview ? (
                                        <div className='uploaded-img position-relative h-160-px w-100 border input-form-light radius-8 overflow-hidden border-dashed bg-neutral-50'>
                                            <button
                                                type='button'
                                                className='uploaded-img__remove position-absolute top-0 end-0 z-1 text-2xxl line-height-1 me-8 mt-8 d-flex bg-danger-600 w-40-px h-40-px justify-content-center align-items-center rounded-circle'
                                                onClick={handleRemoveImage}
                                            >
                                                <iconify-icon
                                                    icon='radix-icons:cross-2'
                                                    className='text-2xl text-white'
                                                ></iconify-icon>
                                            </button>
                                            <img
                                                id='uploaded-img__preview'
                                                className='w-100 h-100 object-fit-cover'
                                                src={imagePreview}
                                                alt='Uploaded'
                                            />
                                        </div>
                                    ) : (
                                        <label
                                            className='upload-file h-160-px w-100 border input-form-light radius-8 overflow-hidden border-dashed bg-neutral-50 bg-hover-neutral-200 d-flex align-items-center flex-column justify-content-center gap-1'
                                            htmlFor='upload-file'
                                        >
                                            <iconify-icon
                                                icon='solar:camera-outline'
                                                className='text-xl text-secondary-light'
                                            ></iconify-icon>
                                            <span className='fw-semibold text-secondary-light'>
                                                Upload
                                            </span>
                                            <input
                                                id='upload-file'
                                                type='file'
                                                hidden
                                                onChange={handleFileChange}
                                            />
                                        </label>
                                    )}
                                </div>
                            </div> */}

                                <div className="col-md-6 col-12">
                                    <label className='form-label fw-bold text-neutral-900'>
                                        Upload File
                                    </label>
                                    <div className='upload-image-wrapper'>
                                        {imagePreview ? (
                                            <div className='uploaded-msg-wrapper h-160-px w-100 border input-form-light radius-8 overflow-hidden border-dashed bg-success-50 d-flex justify-content-between align-items-center px-3'>
                                                <div>
                                                    <p className='mb-1 fw-semibold text-success-700'>Image uploaded successfully</p>
                                                    <p className='mb-0 text-sm text-neutral-700'>{imageName}</p>
                                                </div>
                                                <button
                                                    type='button'
                                                    className='btn btn-sm btn-danger ms-3'
                                                    onClick={handleRemoveImage}
                                                >
                                                    Remove
                                                </button>
                                            </div>
                                        ) : (
                                            <label
                                                className='upload-file h-160-px w-100 border input-form-light radius-8 overflow-hidden border-dashed bg-neutral-50 bg-hover-neutral-200 d-flex align-items-center flex-column justify-content-center gap-1 cursor-pointer'
                                                htmlFor='upload-file'
                                            >
                                                <iconify-icon
                                                    icon='solar:camera-outline'
                                                    className='text-xl text-secondary-light'
                                                ></iconify-icon>
                                                <span className='fw-semibold text-secondary-light'>
                                                    Upload
                                                </span>
                                                <input
                                                    id='upload-file'
                                                    type='file'
                                                    hidden
                                                    accept='image/*'
                                                    onChange={handleFileChange}
                                                />
                                            </label>
                                        )}
                                    </div>
                                </div>

                            </div>
                            <button type='submit' className='btn btn-primary-600 radius-8 col-md-2' disabled={loading && true}>


                                {loading ? "Submitting...." : "Submit"}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
            {/* Sidebar Start */}

        </div>
    );
};

export default AddEmailTemp;
